import { FinancialEntity } from "@project/domain/models/financial-entity/financial-entities.model";

export class CreateFinancialEntity {
    constructor(
        public name: FinancialEntity["name"],
        public type: FinancialEntity["type"],
        public description: FinancialEntity["description"],
        public isActive: FinancialEntity["isActive"],
        public entity: FinancialEntity["entity"],
        public isShared?: FinancialEntity["isShared"],
        public sharedWithEntities?: FinancialEntity["sharedWithEntities"],
    ) { }
}
